import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotificationsState } from '../reducers/notifications';

export const getNotificationsState = createFeatureSelector<NotificationsState>(
  'notifications'
);

export const getUnread = createSelector(
  getNotificationsState,
  (state: NotificationsState) => state.unread
);
export const getUnseen = createSelector(
  getNotificationsState,
  (state: NotificationsState) => state.unseen
);
export const getNotifications = createSelector(
  getNotificationsState,
  (state: NotificationsState) => state.notifications
);
export const getSelectedApplicationUnread = createSelector(
  getNotificationsState,
  (state: NotificationsState) => state.selectedApplicationUnread
);
